// config.http.js
"use strict"

function configHttp($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

configHttp.$inject = ["$httpProvider"];

function interceptor() {
    return {
        request: function(request) {
            return request;
        }
    };
}

interceptor.$inject = [];

export { configHttp };
